import { render, staticRenderFns } from "./LearningTestResult.vue?vue&type=template&id=2ba40511&scoped=true&"
import script from "./LearningTestResult.vue?vue&type=script&lang=js&"
export * from "./LearningTestResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba40511",
  null
  
)

export default component.exports